<template>
	<div class="sidebar-linked-products">
		<div class="row">
			<div class="tab-col col-12">
				<div class="tab-wrap"
				     v-if="firstTab">
					<ul class="tab-list">
						<li class="group-list"
						    v-for="(group, g_index) in firstTab.groups"
						    :key="g_index">
							<span class="group-title">{{ group.title }}</span>
							<ul class="item-list">
								<li class="item"
								    v-for="(item, i_index) in group.items"
								    :key="i_index">
									<b-form-checkbox class="checkbox"
									                 :checked="[itemValues[`${firstTab.key}-${item.id}`]]"
									                 :value="true"
									                 :unchecked-value="false"
									                 @change="handleItemChange(firstTab.key, group.key, item, $event)">
										{{ item.text }}
									</b-form-checkbox>
								</li>
							</ul>
						</li>
					</ul>
				</div>

				<div v-else>
					Keine Produkte zur Auswahl
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';

	export default {
		name: 'ErcoSidebarLinkedProductsMolecule',

		props: {
			data: {
				type: Object,
				default: () => ({
					tabs: [],
				}),
			},
		},

		data() {
			return {
				tabIndex: 0,
			};
		},


		computed: {
			firstTab() {
				return this.data.tabs[0];
			},

			itemValues() {
				return this.data.tabs.reduce((values, tab) =>
					tab.groups.reduce((gValues, group) =>
						group.items.reduce((iValues, item) => {
							iValues[`${tab.key}-${item.id}`] = item.selected;
							return iValues;
						}, gValues),
					values),
				{});
			},
		},


		methods: {
			tabTitle(index) {
				let title = this.data.tabs[index].title;

				const contextlinks = this.data.tabs[index].groups.reduce((count, group) =>
					count + group.items.reduce((groupitemCount, item) =>
						groupitemCount + (item.selected ? 1 : 0)
					, 0)
				, 0);

				if (contextlinks > 0) {
					title = `${title} (${contextlinks})`;
				}

				return title;
			},

			handleItemChange(tabKey, groupKey, item, value) {
				const checked = (value.length > 0);
				const newSidebarValue = Vue.util.extend({}, this.$store.state.sidebar.context);

				if (!newSidebarValue.value[tabKey]) {
					newSidebarValue.value[tabKey] = {};
				}

				if (!newSidebarValue.value[tabKey][groupKey]) {
					newSidebarValue.value[tabKey][groupKey] = {};
				}

				if (newSidebarValue.value[tabKey][groupKey][item.id]) {
					delete newSidebarValue.value[tabKey][groupKey][item.id];
				} else {
					newSidebarValue.value[tabKey][groupKey][item.id] = checked;
				}

				const newSidebarOutputData = Object.assign({}, this.data);
				newSidebarOutputData.tabs.forEach((branch) => {
					if (branch.key === tabKey) {
						branch.groups.forEach((group) => {
							if (group.key === groupKey) {
								group.items.forEach((groupItem) => {
									if (groupItem.id === item.id) {
										groupItem.selected = checked;
										return false;
									}
									return true;
								});
								return false;
							}
							return true;
						});
						return false;
					}
					return true;
				});


				this.$store.dispatch('updateSidebar', {
					context: newSidebarValue,
					outputData: newSidebarOutputData,
				});
			},
		},
	};
</script>

<style lang="scss">
	.sidebar-linked-products {
		padding: 0.5rem;
		padding-top: 1.5rem;

		.tab-wrap {
			padding: 0.5rem;
			border: 1px solid rgba(221, 221, 221, 1);

			.tab-list,
			.item-list {
				list-style-type: none;
			}

			.tab-list {
				padding: 0.5rem;

				.group-list {
					padding: 0;
					padding-bottom: 0.7rem ;

					& > .group-title {
						display: block;
						font-weight: bold;
						margin-bottom: 0.5rem;
					}
				}

				.item-list {
					list-style-type: none;
					padding-left: 1rem;
				}
			}

		}
	}
</style>




// WEBPACK FOOTER //
// LinkedProducts.vue?52dc09b4